import { render, staticRenderFns } from "./PublishInfo.vue?vue&type=template&id=04a3b0a3&scoped=true&"
import script from "./PublishInfo.vue?vue&type=script&lang=js&"
export * from "./PublishInfo.vue?vue&type=script&lang=js&"
import style0 from "./PublishInfo.vue?vue&type=style&index=0&id=04a3b0a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a3b0a3",
  null
  
)

export default component.exports